import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApplyChangesToDevicesComponent } from '../apply-changes-to-devices/apply-changes-to-devices.component';

@NgModule({
  declarations: [ApplyChangesToDevicesComponent],
  imports: [
    CommonModule
  ],
  exports: [ApplyChangesToDevicesComponent]
})
export class ApplyChangesToDeviceModule { }
